export default {
  title: 'Deliverect',
  form: {
    channel_link_id: {
      label: 'ID du lien de canal : ',
    },
    store_id: {
      label: "ID d'emplacement externe : ",
    },
    store_provisioning_url: {
      label: "URL d'approvisionnement du magasin : ",
    },
  },
  buttons: {
    save: 'Enregistrer',
  },
  toasts: {
    error: "Échec de l'enregistrement des modifications",
    success: 'Modifications enregistrées',
  },
  instructions: {
    title: 'Instructions de configuration :',
    step_1:
      "Ouvrez la page <Link>« Locations »</Link> dans Deliverect, développez l'emplacement approprié et cliquez sur le bouton « + Channel link ».",
    step_2:
      "Renseignez les informations nécessaires. À l'étape « Select your online delivery platform », sélectionnez « Food Amigos ».",
    step_3:
      'Terminez toutes les étapes. Ensuite, sur la page « Locations », cliquez sur « Edit » dans le canal « Food Amigos ».',
    step_4: "Dans la barre latérale, cliquez sur l'onglet « Channel connection » et renseignez ces informations :",
    step_5: 'Enregistrez les modifications en cliquant sur le bouton « Save » en haut à droite.',
    step_6:
      "Une fois enregistré, cliquez sur l'icône « More » en haut à droite, puis sur « Register » et enfin sur « Activate ».",
    step_7:
      "Revenez à l'onglet « General », passez l'« Integration status » sur « Active » et enregistrez les modifications.",
    outro: 'Vous pouvez ensuite envoyer le menu depuis Deliverect et créer une commande test.',
  },
  connected: {
    title: 'Deliverect est connecté',
    description: 'Cette intégration est configurée.',
  },
};
